import { DepartmentDto } from "@/core/api/generated/v1";

import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "../components/BaseEntityAutocompleteOrCreate";
import DepartmentAutocomplete, { DepartmentAutocompleteProps } from "./DepartmentAutocomplete";
import DepartmentCreateUpdate, { DepartmentCreateUpdateProps } from "./DepartmentCreateUpdate";
import DepartmentCreateUpdateModal from "./DepartmentCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  DepartmentDto,
  DepartmentCreateUpdateProps["defaultValues"],
  DepartmentAutocompleteProps,
  Pick<DepartmentCreateUpdateProps, "defaultValues">
>;

export default function DepartmentAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      DepartmentDto,
      DepartmentCreateUpdateProps["defaultValues"],
      DepartmentAutocompleteProps,
      Pick<DepartmentCreateUpdateProps, "defaultValues">
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <DepartmentAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new department "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <DepartmentCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <DepartmentCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
